import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { List  } from 'react-virtualized';
import { onSnapshot } from 'mobx-state-tree';

class VirtualizedList extends Component {

  constructor(props) {
    super(props)
    this.gridRef = React.createRef()
  }

  componentDidMount() {
    onSnapshot(this.props.store, snapshot => {
      if (this.gridRef.current) {
        this.gridRef.current.forceUpdateGrid()
      }
    })
  }

  render() {
    const { items, rowHeight, rowRenderer } = this.props
    return (
      <List
        height={this.props.height}
        rowCount={items.length}
        rowHeight={rowHeight}
        rowRenderer={rowRenderer}
        width={this.props.width}
        ref={this.gridRef}
      />
    )
  }
}

export default inject('store')(observer(VirtualizedList));


// WEBPACK FOOTER //
// ./src/components/common/VirtualizedList.js